import store from "@/store";
import { ChatBlockingStatusEnum } from "@/store/chats/types";

export const getIsChatBlocked = (chatId: string): boolean => {
  const blockingStatus = store.getters.GET_CHAT_BLOCKING_STATUS(chatId);
  return blockingStatus !== ChatBlockingStatusEnum.Me;
};
